import { StatisticsUserControls } from './components/statistics-user-controls.tsx'
import { StatisticsTable } from './components/statistics-table.tsx'
import { useCallback, useRef, useState } from 'react'
import { useTableHeight } from '../../common/hooks/use-table-height.ts'

export const Statistics = () => {
  const headerRef = useRef<HTMLDivElement>(null)
  const tableHeight = useTableHeight(headerRef)
  const [refreshKey, setRefreshKey] = useState(0)

  const handleReload = useCallback(() => {
    setRefreshKey((prev) => prev + 1)
  }, [])

  return (
    <>
      <div ref={headerRef}>
        <StatisticsUserControls onReload={handleReload} />
      </div>
      {/* key change forces remount to re-fetch infinite row model data */}
      <StatisticsTable key={refreshKey} height={tableHeight} />
    </>
  )
}
